<template>
	<section class="container-fluid mt-2">
		<div class="row mt-2">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                    <div class="mr-auto">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb clearfix pt-3">
                                <li class="breadcrumb-item active" style="cursor: pointer;" @click="Regresar()">Proyecto</li>
                                <li class="breadcrumb-item active">Dashboard</li>
                            </ol>
                        </nav>
                    </div>
                </nav>
			</div>
		</div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row mt-2">
					<div class="col-12 col-sm-12 col-md-12 col-lg-12">
						<div class="card">
							<div class="card-body p-2">
								<div class="row">
									<div class="col-lg-8">
										<div class="row">
											<div class="col-lg-4">
												<div class="card card-body card-sombra-fuerte pt-2 pb-2">
													<h3 class="bold text-center">Valor de Contrato</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValorContrato))}}</h2>
													<h3 class="text-center text-info bold">{{ValorContratoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Costo Operativo</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(CostoOperativo))}}</h2>
													<h3 class="text-center text-info bold">{{CostoOperativoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">G&A/V/F</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GA))}}</h2>
													<h3 class="text-center text-info bold">{{GAPorcen}} %</h3>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="card card-body card-sombra-fuerte pt-2 pb-2">
													<h3 class="bold text-center">Gasto Total</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GastoTotal))}}</h2>
													<h3 class="text-center text-info bold">{{GastoTotalPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Gasto Operativo</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GastoOperativo))}}</h2>
													<h3 class="text-center text-info bold">{{GastoOperativoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Gasto G&A/V/F</h3>
													<h2 class="text-center bold">$ 0</h2>
													<h3 class="text-center text-info bold">0 %</h3>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="card card-body card-sombra-fuerte pt-2 pb-2">
													<h3 class="bold text-center">Facturado</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Facturado))}}</h2>
													<h3 class="text-center text-info bold">{{FacturadoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Cobrado</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Cobrado))}}</h2>
													<h3 class="text-center text-info bold">{{CobradoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Estimado Total</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Estimado))}}</h2>
													<h3 class="text-center text-info bold">{{EstimadoPorcen}} %</h3>
												</div>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-lg-8">
												<div class="card card-body card-sombra-fuerte pt-2 pb-2 h-100">
													<div class="row">
														<div class="col-lg-12">
															<span class="bold">Progreso Tiempo</span>
															<div class="barra-progreso-dashboard mt-2 d-flex">
																<div class="barra-progreso-dashboard-relleno" style="background-color:#038ED9" :id="'progresotiempo'">
																	<span v-if="ProgresoTiempo>=90" class="h-100 d-flex align-items-center justify-content-end ml-2 bold">{{ProgresoTiempo+' %'}}</span>
																</div>
																<span v-if="ProgresoTiempo<90" class="h-100 d-flex align-items-center ml-2 bold">{{ProgresoTiempo+' %'}}</span>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-lg-12">
															<span class="bold">Progreso Obra</span>
															<div class="barra-progreso-dashboard mt-2 d-flex">
																<div class="barra-progreso-dashboard-relleno" style="background-color:#038ED9" :id="'progresoobra'">
																	<span v-if="ProgresoObra>=90" class="h-100 d-flex align-items-center justify-content-end ml-2 bold">{{ProgresoObra+' %'}}</span>
																</div>
																<span v-if="ProgresoObra<90" class="h-100 d-flex align-items-center ml-2 bold">{{ProgresoObra+' %'}}</span>
															</div>
														</div>
													</div>
													<div class="row mt-3">
														<div class="col-lg-4 p-0">
															<h3 class="text-center">Costos Totales</h3>
															<apexchart v-if="ShowPieCostoTotal" height="284" :options="OptionsCostoTotal" :series="SeriesCostoTotal"></apexchart>
														</div>
														<div class="col-lg-4 p-0">
															<h3 class="text-center">Costos Operativos</h3>
															<apexchart v-if="ShowPieCostoOperativo" height="284" :options="OptionsCostoOperativo" :series="SeriesCostoOperativo"></apexchart>
														</div>
														<div class="col-lg-4 p-0">
															<h3 class="text-center">Plan v/s Adicionales</h3>
															<apexchart v-if="ShowPiePlanAdicionales" height="284" :options="OptionsPlanAdicionales" :series="SeriesPlanAdicionales"></apexchart>
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="card card-body card-sombra-fuerte pt-2 pb-2">
													<h3 class="bold text-center">Utilidad Actual</h3>
													<h2 class="text-center bold">$ 0</h2>
													<h3 class="text-center text-info bold">0 %</h3>
													<hr>
													<h3 class="bold text-center">Utilidad Plan</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(UtilidadPlan))}}</h2>
													<h3 class="text-center text-info bold">{{UtilidadPlanPorcen}} %</h3>
												</div>
												<div class="card card-body card-sombra-fuerte pt-2 mt-3 pb-2">
													<h3 class="bold text-center">Financiamiento</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Financiamiento))}}</h2>
													<h3 class="text-center text-info bold">{{FinanciamientoPorcen}} %</h3>
													<hr>
													<h3 class="bold text-center">Adicionales</h3>
													<h2 class="text-center bold">$ {{formateoMillon(parseFloat(Adicionales))}}</h2>
													<h3 class="text-center text-info bold">{{AdicionalesPorcen}} %</h3>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-4">
										<div class="card card-body card-sombra-fuerte h-100">
											<h3 class="bold text-center">Gasto Total</h3>
											<h2 class="text-center bold">$ {{formateoMillon(parseFloat(GastoTotal))}}</h2>
											<div class="row vh-100">
												<div class="col-lg-12" v-if="this.ShowRubros">
													<apexchart ref="graficorubro" width="100%" height ="100%" :options="OptionsRubros" :series="SeriesRubros" ></apexchart>
												</div>
											</div>
											<!-- <div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Equipos</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'equiposgasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Materiales</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'materialesgasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Mano de Obra</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'manoobragasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Vehículos</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'vehiculosgasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Contratistas</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'contratistasgasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Viáticos</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'viaticosgasto'"></div>
													</div>
												</div>
											</div>
											<div class="row mt-5">
												<div class="col-lg-3">
													<span class="bold">Burden</span>
												</div>
												<div class="col-lg-9">
													<div class="barra-progreso">
														<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'burdengasto'"></div>
													</div>
												</div>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</CLoader>
		
	</section>
</template>

<script>
import CLoader from "@/components/CLoader.vue";
export default {
	name:'dashboardproyecto',
	props:['pIdProyecto'],
	components:{CLoader},
	data() {
		return {
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true
			},
			IdProyecto:0,
			ValorContrato:0,
			ValorContratoPorcen:100,
			CostoOperativo:0,
			CostoOperativoPorcen:0,
			GA:0,
			GAPorcen:25,
			GastoTotal:0,
			GastoTotalPorcen:0,
			GastoOperativo:0,
			GastoOperativoPorcen:0,
			GastoGA:0,
			GastoGAPorcen:0,
			Facturado:0,
			FacturadoPorcen:0,
			Cobrado:0,
			CobradoPorcen:0,
			Estimado:0,
			EstimadoPorcen:0,
			UtilidadActual:0,
			UtilidadActualPorcen:0,
			UtilidadPlan:0,
			UtilidadPlanPorcen:0,
			Financiamiento:0,
			FinanciamientoPorcen:0,
			Adicionales:0,
			AdicionalesPorcen:0,
			ProgresoTiempo:0,
			ProgresoObra:0,
			Equipos:0,
			Materiales:0,
			ManoObra:0,
			Vehiculos:0,
			Contratistas:0,
			Viaticos:0,
			Burden:0,
			ShowPieCostoTotal:false,
			OptionsCostoTotal:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels:{
					enabled: true,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						},
					},
					textAnchor:'start'
				},
				plotOptions:{
					pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
				},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': '+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Gasto Total','Gasto Operativo'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			SeriesCostoTotal:[0,0],
			ShowPieCostoOperativo:false,
			OptionsCostoOperativo:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels:{
					enabled: true,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						},
					},
					textAnchor:'start'
				},
				plotOptions:{
					pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
				},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': '+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Valor Contrato','Gasto Operativo'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			SeriesCostoOperativo:[0,0],
			ShowPiePlanAdicionales:false,
			OptionsPlanAdicionales:{
				chart: {
					type: "pie",
					width: 380,
					height: 280
				},
				dataLabels:{
					enabled: true,
					formatter(val, opts) {
                		// return opts.w.config.series[opts.seriesIndex];
						let fixed = 0;
						let e=0;
						if (opts.w.config.series[opts.seriesIndex] === null) {
							return null;
						} // terminate early
						if (opts.w.config.series[opts.seriesIndex] === 0) {
							return "0";
						} // terminate early
						fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
						var b = opts.w.config.series[opts.seriesIndex].toPrecision(2).split("e"), // get power
							k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
							c =
								k < 1
									? opts.w.config.series[opts.seriesIndex].toFixed(0 + fixed)
									: (opts.w.config.series[opts.seriesIndex] / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
							d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
							if (k==0) {
								// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
								e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
							}
							else{
								e = d + ["", " M", " B", " T"][k]; // append power
							}
						return e;
              		},
					style:{
						fontSize:'19px',
						fontWeight:'bold',
						fontFamily:'Arial'
					},
					background:{
						dropShadow:{
							enabled:true,
							top: 1,
      						left: 1,
      						blur: 1,
							opacity:1
						},
					},
					textAnchor:'start'
				},
				plotOptions:{
					pie: {
              		  dataLabels: {
              		    offset: -25,
              		  },
              		},
				},
				tooltip:{
					y:{
						formatter(val){
							let fixed = 0;
							let e=0;
							if (val === null) {
								return null;
							} // terminate early
							if (val === 0) {
								return "0";
							} // terminate early
							fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
							var b = val.toPrecision(2).split("e"), // get power
								k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
								c =
									k < 1
										? val.toFixed(0 + fixed)
										: (val / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
								d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
								if (k==0) {
									// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
									e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}
								else{
									e = d + ["", " M", " B", " T"][k]; // append power
								}
							return e;
						},
					},
					custom: function ({series,seriesIndex,dataPointIndex,w}) {
                    	// console.log(w.config);
						return (
                    	    '<div class="" style="background-color:'+w.config.colors[seriesIndex]+';font-size:16px;">' +
                    	    "<span>" +
                    	    w.config.labels[seriesIndex]+': '+series[seriesIndex]
							+
                    	    "</span>" +
                    	    "</div>"
                    	);
                	},
					style:{
						fontSize:'14px'
					},
				},
				labels:['Valor Contrato','Adicionales'],
				responsive:[{
					breakpoint: 480,
					options:{
						chart: {
							width:200
						}
					}
				}],
				legend:{
					show:false
				},
				colors:['#038ED9', '#1B17BB']
			},
			SeriesPlanAdicionales:[0,0],
			ShowRubros:false,
			OptionsRubros:{
				chart: {
                	type: 'bar',
                	height: 280,
                	toolbar: {
                	    show: false
                	},
            	},
				plotOptions: {
            	    bar: {
            	        horizontal: true,
            	        barHeight: '80%',
            	        distributed: true,
            	        dataLabels: {
            	            position: 'top',
            	        },
            	    },
            	},
				dataLabels:{
					enabled: true,
                	offsetX: 100,
					formatter: (value,{seriesIndex,dataPointIndex,w})=>{
						// console.log(w.config.yaxis[0].max);
						let sum = w.config.yaxis[0].max;
              			let percent = isNaN((value / sum) * 100) ? 0 : (value / sum) * 100;
						// this.flag=false;
                    	return "$" + this.formateoMillon(value)+' - '+percent.toFixed(0)+'%';
					},
					style: {
                    	fontSize: '13px',
                    	colors: ['']
                	}
				},
				stroke: {
                	show: true,
                	width: 1,
                	colors: ['#fff']
            	},
				tooltip: {
            	    custom: function ({
            	        series,
            	        seriesIndex,
            	        dataPointIndex,
            	        w
            	    }) {
            	        return (
            	            '<div class="arrow_box">' +
            	            "<span>" +
            	            w.globals.labels[dataPointIndex] +
            	            ": " + "$"+
            	            series[seriesIndex][dataPointIndex].toFixed(1)+
            	            "</span>" +
            	            "</div>"
            	        );
            	    }
            	},
				xaxis: {
                	categories: ['Equipos','Materiales', 'Mano de Obra', 'Vehículos','Contratistas','Viáticos','Burden'],
                	labels: {
                	    show: true,
                	    formatter: (value) => {
                	        return "$" + this.formateoMillon(value)

                	    },
                	    style: {
                	        colors: ['#0F3F87'],
                	        fontSize: '13px',
                	        fontFamily: 'Barlow, sans-serif',
                	        fontWeight: 400,
                	        cssClass: 'apexcharts-xaxis-label',
                	    }
                	},

            	},
				colors: ['#038ED9'],
				legend:{
					show:false
				},
				yaxis: [{
            	    labels: {
            	        style: {
            	            colors: ['#0F3F87'],
            	            fontSize: '13px',
            	            fontFamily: 'Barlow, sans-serif',
            	            fontWeight: 'bold',
            	        },
            	    },
					min:0,
					max:this.GastoTotal,
            	}],
				
			},
			SeriesRubros:[]
		}
	},
	methods: {
		async GetInfo(){
			await this.$http.get('proyectosdashboard/get',{
				params:{
					IdProyecto:this.IdProyecto
				}
			}).then((res) => {
				this.ValorContrato=res.data.data.Venta;
				this.CostoOperativo=res.data.data.CostoOperativo;
				this.CostoOperativoPorcen=res.data.data.CostoOperativoPorcen;
				this.GA=res.data.data.GA;
				this.GastoTotal=res.data.data.CostoOperativo;
				this.GastoTotalPorcen=res.data.data.CostoOperativoPorcen;
				this.GastoOperativo=res.data.data.GastoOperativo;
				this.GastoOperativoPorcen=res.data.data.GastoOperativoPorcen;
				this.Facturado=res.data.data.Facturado;
				this.FacturadoPorcen=res.data.data.FacturadoPorcen;
				this.Cobrado=res.data.data.Cobrado;
				this.CobradoPorcen=res.data.data.CobradoPorcen;
				this.Estimado=res.data.data.Estimado;
				this.EstimadoPorcen=res.data.data.EstimadoPorcen;
				this.UtilidadPlan=res.data.data.UtilidadPlan;
				this.UtilidadPlanPorcen=res.data.data.UtilidadPlanPorcen;
				this.Financiamiento=res.data.data.Financiamiento;
				this.FinanciamientoPorcen=res.data.data.FinanciamientoPorcen;
				this.Adicionales=res.data.data.Adicionales;
				this.AdicionalesPorcen=res.data.data.AdicionalesPorcen;
				this.ProgresoTiempo=res.data.data.ProgresoTiempo;
				this.ProgresoObra=res.data.data.Progreso;
				// this.Equipos=res.data.data.EquiposPorcen;
				// this.Materiales=res.data.data.MaterialesPorcen;
				// this.ManoObra=res.data.data.ManoObraPorcen;
				// this.Vehiculos=res.data.data.VehiculosPorcen;
				// this.Contratistas=res.data.data.ContratistasPorcen;
				// this.Viaticos=res.data.data.ViaticosPorcen;
				// this.Burden=res.data.data.BurdenPorcen;

				let ElementoTiempo=document.getElementById('progresotiempo');
				let ElementoObra=document.getElementById('progresoobra');
				// let ElementoEquipo=document.getElementById('equiposgasto');
				// let ElementoMaterial=document.getElementById('materialesgasto');
				// let ElementoManoObra=document.getElementById('manoobragasto');
				// let ElementoVehiculo=document.getElementById('vehiculosgasto');
				// let ElementoContratista=document.getElementById('contratistasgasto');
				// let ElementoViatico=document.getElementById('viaticosgasto');
				// let ElementoBurden=document.getElementById('burdengasto');
				ElementoTiempo.style.width=Number(this.ProgresoTiempo)>=100 ? 100+'%' : this.ProgresoTiempo+'%';
				ElementoObra.style.width=Number(this.ProgresoObra)>=100 ? 100+'%' : this.ProgresoObra+'%';
				// ElementoEquipo.style.width=Number(res.data.data.EquiposPorcen)>=100 ? 100+'%' : res.data.data.EquiposPorcen+'%';
				// ElementoMaterial.style.width=Number(res.data.data.MaterialesPorcen)>=100 ? 100+'%' : res.data.data.MaterialesPorcen+'%';
				// ElementoManoObra.style.width=Number(res.data.data.ManoObraPorcen)>=100 ? 100+'%' : res.data.data.ManoObraPorcen+'%';
				// ElementoVehiculo.style.width=Number(res.data.data.VehiculosPorcen)>=100 ? 100+'%' : res.data.data.VehiculosPorcen+'%';
				// ElementoContratista.style.width=Number(res.data.data.ContratistasPorcen)>=100 ? 100+'%' : res.data.data.ContratistasPorcen+'%';
				// ElementoViatico.style.width=Number(res.data.data.ViaticosPorcen)>=100 ? 100+'%' : res.data.data.ViaticosPorcen+'%';
				// ElementoBurden.style.width=Number(res.data.data.BurdenPorcen)>=100 ? 100+'%' : res.data.data.BurdenPorcen+'%';
				//GRAFICA DE RUBROS
				this.OptionsRubros.yaxis[0].max=this.GastoTotal;
				// console.log(this.OptionsRubros.yaxis[0].max);
				// this.OptionsRubros.xaxis[0].max=this.GastoOperativo;
				let NewArray=[res.data.data.Equipos,res.data.data.Materiales,res.data.data.ManoObra,res.data.data.Vehiculos,res.data.data.Contratistas,res.data.data.Viaticos,res.data.data.Burden];
				this.SeriesRubros = [{
					data: NewArray,
				}];
				// this.SeriesRubros[7],res.data.data.Equipos;
				// GRAFICA DE COSTO TOTAL
				this.SeriesCostoTotal[0]=this.ValorContrato;
				this.SeriesCostoTotal[1]=this.GastoOperativo;
				this.SeriesCostoOperativo[0]=this.GastoTotal;
				this.SeriesCostoOperativo[1]=this.GastoOperativo;
				this.SeriesPlanAdicionales[0]=this.ValorContrato;
				this.SeriesPlanAdicionales[1]=this.Adicionales;
			}).finally(()=>{
				this.ShowPieCostoTotal=true;
				this.ShowPieCostoOperativo=true;
				this.ShowPiePlanAdicionales=true;
				this.ShowRubros=true;
				this.ConfigLoad.ShowLoader=false;
			})
		},
		Regresar(){
			this.$router.push({name:'proyectodesglose'});
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
	},
	created() {
		if (this.pIdProyecto!=undefined) {
			sessionStorage.setItem("IdProyecto",this.pIdProyecto);
		}
		this.IdProyecto=sessionStorage.getItem("IdProyecto");
	},
	mounted() {
		this.GetInfo();
	},
}
</script>

<style>

</style>
